import { Button } from "@mantine/core";
import { ReactElement } from "react";
import {
  DEFAULT_RED_COLOR,
  DEFAULT_WHITE_COLOR,
} from "../../../_graphic_design";

interface Props {
  disabled?: boolean;
  label: string;
  onClick: () => void;
  visible?: boolean;
}

export default function Btn({
  disabled = false,
  label,
  onClick,
  visible = true,
}: Props): ReactElement {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      style={{
        backgroundColor: DEFAULT_RED_COLOR,
        borderColor: DEFAULT_WHITE_COLOR,
        color: DEFAULT_WHITE_COLOR,
        marginTop: "10px",
        visibility: visible ? "visible" : "hidden",
      }}
      tt="uppercase"
    >
      <span dangerouslySetInnerHTML={{ __html: label }} />
    </Button>
  );
}
